export enum FieldNames {
  FormCategories = 'formCategories',
  Reset = 'reset',
}
